<template>
<div class="notice">
  <div
    v-if="listData.length"
    class="top-module">
    <h5>{{$t('About.notice')}}</h5>
    <el-button
      color="primary"
      :loading="realAllLoading"
      @click="readAllHandle"
    >{{$t('All_have_been_read')}}</el-button>
  </div>
  <div class="message-list">
    <div
      v-if="nullDataFlag"
      class="no-data"
    >{{$t('root.noData')}}</div>
    <div
      v-for="(item,index) in listData"
      :key="index"
      class="message-item has-img">
<!--      需要调整,todo
1.点击图片或标题，均可打开公告弹窗，且标记为已读。
2.如未上传封面则不显示不占位。
-->
      <img
        @click="itemHandle(item)"
        v-if="item.coverImgUrl"
        class="img-el pointer" :src="item.coverImgUrl" alt="">
      <div class="image-right">
        <p
          @click="itemHandle(item)"
          class="title pointer">
          <span
            v-if="!item.readFlag"
            class="cicle"></span>
          {{ item.title }}
        </p>
        <div class="time">{{parseTime(item.updateTime,'{y}-{m}-{d} {h}:{i}')}}</div>
      </div>
    </div>
  </div>
  <div class="pagination-outer" v-if="total > 10">
    <div class="paginnation-left">
      <size-change @sizeChange="sizeChange"></size-change>
      <span class="tatol-count">{{$t('total')}} {{total}} {{$t('item')}}</span>
    </div>
    <vs-pagination
      class="pagination-box"
      :max="max"
      :total="pageSize"
      v-model="page"
    ></vs-pagination>
  </div>
  <notice-dialog
    ref="notice"
    :notice-dialog-show="dialogShow"
    :notice-info="currentRow"
    @close="closeNoticeDialog"
  ></notice-dialog>
</div>
</template>

<script>
import { parseTime } from "@/utils";
import { queryNoticeDialog, readAllPopUpNotice,readNoticeDialog } from '@/api/user'
import { mapGetters } from 'vuex'
import initData from '@/mixins/initData'
import noticeDialog from "@/components/message/noticeDialog";
import {queryAccountLimit} from "@/api/userCenter";
export default {
  name: "index",
  components:{
    noticeDialog
  },
  data() {
    return {
      total: 0,
      currentRow: {
        id: '',
      },
      dialogShow: false,
      realAllLoading: false,
    }
  },
  mixins: [initData],
  computed: {
    ...mapGetters(['userInfo', 'listRefresh','userInfo','agentRole']),
    nullDataFlag(){
      return this.listData !== null && !this.listData.length;
    },
    isCustomerView(){
      return this.userInfo.custType == 3 || (this.userInfo.custType == 1 && this.agentRole == 'CUSTOMER');
    },
  },
  created(){

    this.init();
  },
  methods: {
    parseTime,
    beforeInit(){
      this.url = '/crm/reception/popUpNoticeList';
      this.params = {
        custId: this.userInfo.id,
        page: this.page -1,
        size: this.size,
        receiverType: this.isCustomerView ? 1: 2,
      }
      return true;
    },

    queryNoReadNoticeCount(){
      // 查询全部的,公告和消息全部的未读消息
      queryAccountLimit({
        custId: this.userInfo.id,
      }).then((res) => {
        this.$emit('send-PopUp-count',res.data.totalUnreadNumber);
      })
    },
    readAllHandle() {
      this.realAllLoading = true;
      readAllPopUpNotice({custId: this.userInfo.id}).then((res) => {
        this.realAllLoading = false;
        this.$emit('readall-popUp');
        this.page = 1;
        this.init();
      })
    },
    itemHandle(item){
      if(item.contentType == 1){
        this.currentRow = item;
        readNoticeDialog({
          custId: this.userInfo.id,
          popUpId: item.id,
        }).then((res) => {
        });
        this.dialogShow = true;
      }else {
        readNoticeDialog({
          custId: this.userInfo.id,
          popUpId: item.id,
        }).then((res) => {
          window.open(item.content,'_blank')
        });
      }
    },
    closeNoticeDialog(){
      this.dialogShow = false;
      this.page = 1;
      this.init();
      this.$emit('refresh-popUp-count');
    },
  },
}
</script>

<style lang="scss" scoped>
.notice {
  .no-data {
    text-align: center;
  }
  .img-el {
    width: 94px;
    height: 50px;
    margin-right: 8px;
  }
}
</style>
